import { render, staticRenderFns } from "./ModalRiskDrivers.vue?vue&type=template&id=352e8559&scoped=true"
import script from "./ModalRiskDrivers.vue?vue&type=script&lang=js"
export * from "./ModalRiskDrivers.vue?vue&type=script&lang=js"
import style0 from "./ModalRiskDrivers.vue?vue&type=style&index=0&id=352e8559&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352e8559",
  null
  
)

export default component.exports